import { parsePagingQuery } from "../../../../../handlers/filter";
/**
 * @param filters: array of SDK-style publisher caps filters.
 * @param sort: optional. Information on the field and direction of sorting, if any.
 * @return: a proper query string for the supplied filters.
 */
export const toQueryParams = (filters) => {
    const params = `${parsePagingQuery(filters.paging)}`;
    return params.length ? `?${params}` : "";
};
//# sourceMappingURL=params.js.map